import styled from "styled-components";

const HashtagLink = styled.a`
  background: ${({ theme }) => theme.palette.grey[50]};
  display: inline-block;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  line-height: 22px;
  padding: 4px 12px;
  margin: 0 10px 10px 0;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.palette.blueGrey[200]};
    color: inherit;
  }
  color: inherit;
`;

export default HashtagLink;
